import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { QuizConfigProvider } from '@mentimeter/quiz';
import { ViewOnlyPresentationDataHandler } from './ViewOnlyPresentationDataHandler';
import { LivePresentationDataHandler } from './LivePresentationDataHandler';

export function QuizOpenPresentationDataHandler() {
  const { useQuestion, useVotingInstructions, useConfig } =
    usePresentationContext();
  const { voteKey } = useVotingInstructions();
  const { mode } = useConfig();
  const { public_key, slideAdminKey } = useQuestion();

  return (
    <QuizConfigProvider
      questionPublicKey={public_key}
      questionAdminKey={slideAdminKey}
      voteKey={voteKey}
    >
      {mode !== 'live' ? (
        <ViewOnlyPresentationDataHandler />
      ) : (
        <LivePresentationDataHandler />
      )}
    </QuizConfigProvider>
  );
}
